import { memo } from 'react';
import { Box, Flex, Heading } from '@chakra-ui/layout';
import styled from 'styled-components';

const oopsImg = require('assets/images/form-oops.png').default;

const Img = styled.img`
  max-width: 480px;
  margin-bottom: 20px;
`;

const UnfilledStep = styled.div`
  width: 400px;
  height: 45px;
  display: flex;
  align-items: center;
  padding-left: 28px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors[1300]};
  font-weight: bold;
`;

const ErrorComp = ({ unfilledSteps }: { unfilledSteps: string[] }) => {
  return (
    <Flex alignItems="center" marginTop="1rem" width="100%" direction="column">
      <Img src={oopsImg} />
      <Heading mb=".8rem" size="lg" as="h3">
        Oops,
      </Heading>
      {unfilledSteps.length > 0 && (
        <>
          <Heading color="brand.tertiary" mb="1rem" size="xs" as="h4">
            Parece que algumas etapas não foram preenchidas
          </Heading>
          <Box
            borderRadius="4px"
            width="fit-content"
            height="fit-content"
            bg="brand.tertiary"
            mt="1rem"
          >
            {unfilledSteps.map((i, k) => (
              <UnfilledStep key={k}>{i}</UnfilledStep>
            ))}
          </Box>
        </>
      )}
    </Flex>
  );
};

export const UnfilledError = memo(ErrorComp);
